import { onMounted } from "vue"

import { useAppStore } from "@/stores/app"
import { storeToRefs } from "pinia"

export default function useUpgradeModal() {
  const appStore = useAppStore()

  const { showModalUpgradeToPro } = storeToRefs(appStore)

  onMounted(() => appStore.loadPlans())

  return {
    visible: showModalUpgradeToPro
  }
}
